var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRoundedMagnifer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1346)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 8.25,
    r: 6.75,
    stroke: "#1C274C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.359 15.7311C16.312 15.8021 16.227 15.8871 16.0571 16.0571C15.8871 16.227 15.8021 16.312 15.7311 16.359C15.3152 16.6345 14.7525 16.4925 14.517 16.0527C14.4768 15.9777 14.4423 15.8625 14.3733 15.6323C14.2979 15.3807 14.2602 15.2549 14.2529 15.1664C14.21 14.6452 14.6452 14.21 15.1664 14.2529C15.2549 14.2602 15.3807 14.2979 15.6323 14.3733C15.8625 14.4423 15.9777 14.4768 16.0527 14.517C16.4925 14.7525 16.6345 15.3152 16.359 15.7311Z",
    stroke: "#1C274C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedMagnifer);
export default __webpack_public_path__ + "static/media/icon_rounded_magnifer.fcec078ed693ff847bffdc3794eba209.svg";
export { ForwardRef as ReactComponent };